import { useTracking } from 'react-tracking';
import { useMount } from '@simplywallst/ui-core';
import { useSelector } from 'react-redux';
import { getLocationPayload } from '@/redux/location/selectors';
import { NarrativeCommunity } from '../components/NarrativeCommunity';

export const NarrativeCommunityPage = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
  });
  useMount(() => {
    trackEvent({ subject: 'page', action: 'landed' });
  });

  const payload = useSelector(getLocationPayload);
  const {
    companyname: companyNameSlug,
    country: market,
    exchange_ticker: exchangeTicker,
    industry: primaryIndustrySlug,
  } = (payload ?? {}) as Record<string, string | undefined>;

  return (
    <Track>
      <div className="w-full max-w-screen-xl p-x2 lg:p-x3 grid gap-x2">
        <NarrativeCommunity
          market={market}
          primaryIndustrySlug={primaryIndustrySlug}
          companyNameSlug={companyNameSlug}
          exchangeTicker={exchangeTicker}
        />
      </div>
    </Track>
  );
};
